var React = require('react');

function WaveBottomCenter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m-0.64117 0.34562c54.753 3.448 46.054 16.882 88.975 43.567 42.921 26.685 38.201-39.374 124.93-43.567v56.047h-213.9z","fill":"#fff"}));
}

WaveBottomCenter.defaultProps = {"width":"800","height":"200","preserveAspectRatio":"none","version":"1.1","viewBox":"0 0 211.67 52.917"};

module.exports = WaveBottomCenter;

WaveBottomCenter.default = WaveBottomCenter;
